import axios from "axios";

import portalEnvironment from "../Utils/baseURL";

import { sair, getCurrentAuthenticatedUser } from "./auth";
// import device from "./deviceInfos";

const getTokenCognito = async () => {
  // solicita ao cognito um novo token do usuário autenticado
  let resultGetAuthenticatedUser = null;

  try {
    resultGetAuthenticatedUser = await getCurrentAuthenticatedUser();

    const token =
      resultGetAuthenticatedUser?.signInUserSession?.idToken?.jwtToken;
    localStorage.removeItem("tokenCognito");
    localStorage.setItem("tokenCognito", token);

    return token;
  } catch (error) {
    await sair();
    console.error(error);
    return null;
  }
};

const apiNotSensedia = axios.create({
  baseURL: portalEnvironment.BaseUrlNotSensedia,
  timeout: 300000,
  headers: {
    authorization: `Bearer ${localStorage.getItem("tokenCognito")}`,
    client_id: "cdf44a30-32a4-3930-9e82-4ee8a8a7d8f0",
    access_token: localStorage.getItem("idTokenSens"),
    // device: JSON.stringify(device),
  },
});

const setAuthorizationNotSensedia = async (token) => {
  if (!token) {
    token = await getTokenCognito();
    apiNotSensedia.defaults.headers.authorization = `Bearer ${token}`;
  } else apiNotSensedia.defaults.headers.authorization = `Bearer ${token}`;
};

// apiNotSensedia.interceptors.response.use(undefined, async (error) => {
//   if (error?.response?.status === 403) {
//     await sair();
//   } else if (error?.response?.status === 401) {
//     if (await callBackError401()) {
//       error.config.headers.authorization =
//         apiNotSensedia.defaults.headers.authorization;
//       return apiNotSensedia.request(error.config);
//     } else {
//       await sair();
//     }
//   }
//   return Promise.reject(error);
// });

// async function callBackError401() {
//   try {
//     let tempGetToken = await getTokenCognito();
//     if (tempGetToken) {
//       setAuthorizationNotSensedia(tempGetToken);
//       return true;
//     } else {
//       return false;
//     }
//   } catch (error) {
//     return false;
//   }
// }
export { setAuthorizationNotSensedia, apiNotSensedia };
